import React, { useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Flex,
  Box,
  Heading,
  Text,
  IconButton,
  Image,
  MenuItem,
  MenuButton,
  Menu,
  MenuList,
  useToast,
  AlertIcon,
  Alert,
  Button,
  useDisclosure,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Modal,
} from "@chakra-ui/react";
import {
  DeleteIcon,
  EditIcon,
  ExternalLinkIcon,
  HamburgerIcon,
} from "@chakra-ui/icons";
import { useParams } from "react-router-dom";
import { deleteDoc, doc } from "firebase/firestore";
import { db, storage } from "../firebase-config";
import { deleteObject, ref } from "firebase/storage";
import moment from "moment";
import "moment/locale/pt-br";
import AddEditMotorista from "./AddEditMotorista";
import { saveAs } from "file-saver";

const MotoristaInfo = ({ motoristas, getMotoristas, setLoading }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { carroId, filialId } = useParams();
  const toast = useToast();
  useEffect(() => {
    carroId, filialId;
  }, [carroId, filialId]);

  const DeleteMotorista = async () => {
    // Create a reference to the file to delete
    const desertRef = ref(storage, `CNHS/${motoristas.id}`);
    // Delete the file

    {
      motoristas.cnh
        ? await deleteObject(desertRef)
            .then(() => {
              // File deleted successfully
              console.log("Imagem excluida");
            })
            .catch((error) => {
              // Uh-oh, an error occurred!
              console.log("erro: " + error);
            })
        : null;
    }

    try {
      deleteDoc(
        doc(
          db,
          "/FILIAIS/91IYpjJbXYN99Asq2Enw/",
          filialId,
          carroId,
          "Motoristas",
          motoristas.id
        )
      );
      setTimeout(() => {
        getMotoristas();
      }, 1000);
      ToastMotoristaDelete();
    } catch (e) {
      toast({
        title: "E-mail ou senha inválidos. Verifique-os!",
        status: "error",
        duration: 5000,
        isClosable: false,
      });
    }
  };

  const ToastMotoristaDelete = () => {
    return toast({
      title: "Motorista excluido com sucesso!",
      position: "bottom",
      status: "success",
      variant: "top-accent",
      duration: 3000,
      isClosable: true,
    });
  };

  const validadeCNHFormatada = moment(motoristas.cnh_validade)
    .locale("pt-br")
    .format("LL");
  const diasVencimento = moment(motoristas.cnh_validade).diff(moment(), "days");

  const downloadImage = () => {
    saveAs(motoristas.cnh_image, "image.jpg"); // Put your image url here.
  };

  return (
    <Card maxW="md" boxShadow="lg" rounded="md">
      <CardHeader>
        <Flex spacing="4">
          <Flex flex="1" gap="4" alignItems="center" flexWrap="wrap">
            <Box>
              <Heading size="md">{motoristas.nome}</Heading>
            </Box>
          </Flex>
          <Menu>
            <MenuButton
              as={IconButton}
              aria-label="Options"
              icon={<HamburgerIcon />}
              variant="outline"
            />
            <MenuList>
              {/* <MenuItem icon={<EditIcon />}>Editar</MenuItem> */}
              <AddEditMotorista
                motoristaId={motoristas.id}
                setLoading={setLoading}
                getMotoristas={getMotoristas}
              />
              <MenuItem icon={<DeleteIcon />} onClick={DeleteMotorista}>
                Excluir
              </MenuItem>
              <MenuItem
                icon={<ExternalLinkIcon />}
                variant="ghost"
                onClick={onOpen}
              >
                Abrir imagem inteira
              </MenuItem>
              <Modal
                size={"full"}
                isCentered
                onClose={onClose}
                isOpen={isOpen}
                motionPreset="slideInBottom"
              >
                <ModalOverlay />
                <ModalContent>
                  {/* <ModalHeader>CNH</ModalHeader> */}
                  <ModalCloseButton />
                  <ModalBody>
                    {motoristas.cnh_image ? (
                      <Flex direction={"row"}>
                        <Image
                          objectFit="cover"
                          src={motoristas.cnh_image}
                          alt="motorista-img"
                          rounded="md"
                          maxW="xl"
                          maxH="xl"
                        />
                      </Flex>
                    ) : null}
                  </ModalBody>
                  <ModalFooter>
                    <Button variant="outline" mr={3} onClick={onClose}>
                      Fechar
                    </Button>
                    <Button
                      colorScheme="blue"
                      onClick={() =>
                        window.open(motoristas.cnh_image, "_blank")
                      }
                    >
                      Baixar CNH
                    </Button>

                    {/* <a href={motoristas.cnh_image} download>
                      <Button colorScheme="green">Baixar</Button>
                    </a> */}
                  </ModalFooter>
                </ModalContent>
              </Modal>
            </MenuList>
          </Menu>
        </Flex>
        <Text pt={5}>CNH: {motoristas.cnh} </Text>

        <Text pt={2}>
          VENCIMENTO:{" "}
          {motoristas.cnh_validade
            ? validadeCNHFormatada
            : " Validade não informada"}
        </Text>

        {diasVencimento > 15 ? (
          <Box pt={2}>Faltam {diasVencimento} dias para vencer a CNH</Box>
        ) : null}

        <Text pt={2}>CATEGORIA: {motoristas.cnh_categoria}</Text>
        <Text pt={2}>ID: {motoristas.id} </Text>
      </CardHeader>
      {motoristas.cnh_image ? (
        <Flex
          direction={"column"}
          alignItems={"center"}
          alignContent={"flex-end"}
        >
          <Image
            objectFit="cover"
            src={motoristas.cnh_image}
            alt="motorista-img"
            rounded="md"
            maxW="lg"
            maxH="lg"
            maxWidth={"300px"}
          />
        </Flex>
      ) : null}

      {diasVencimento <= 0 ? (
        <Flex justifyContent="center" flex={1}>
          <Alert
            justifyContent="center"
            status="error"
            width="100%"
            rounded="md"
            borderColor="red.500"
          >
            <AlertIcon />
            {diasVencimento >= 0
              ? `CNH Vencida há ${diasVencimento} dias`
              : `CNH vencida há ${Math.abs(diasVencimento)} dias`}
          </Alert>
        </Flex>
      ) : diasVencimento <= 15 ? (
        <Flex justifyContent="center" flex={1}>
          <Alert
            justifyContent="center"
            status="warning"
            width="100%"
            rounded="md"
            borderColor="yellow.500"
          >
            <AlertIcon />
            CNH irá vencer em {diasVencimento} dias
          </Alert>
        </Flex>
      ) : (
        <></>
      )}
    </Card>
  );
};

export default MotoristaInfo;
